import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";
import { Skeleton } from "@mui/material";
import { tokens, fmtNumber } from "../../shared/clinical-design";

// Series de health status con semántica clínica (no decoración).
const STATUS_SERIES = [
  { key: "Well", color: tokens.ok },
  { key: "Acute", color: tokens.info },
  { key: "Chronic", color: tokens.primary },
  { key: "At Risk", color: tokens.warn },
  { key: "Complex", color: tokens.crit },
  { key: "End of Life", color: "#7A241B" },
  { key: "No Status", color: tokens.lineStrong },
];

const tick = { fontFamily: tokens.fontMono, fontSize: 10.5, fill: tokens.ink3 };

/**
 * Distribución de health status por centro (barras apiladas, paleta clínica).
 *
 * @param {Object[]} centers - [{ label, healthStatusDistribution }]
 * @param {boolean} [loading]
 */
export default function HealthStatusChart({ centers = [], loading = false }) {
  if (loading) return <Skeleton variant="rectangular" height={270} />;

  const rows = centers.map((c) => ({
    center: c.label,
    ...c.healthStatusDistribution,
  }));

  return (
    <ResponsiveContainer width="100%" height={270}>
      <BarChart data={rows} margin={{ top: 4, right: 8, left: 0, bottom: 4 }}>
        <CartesianGrid stroke={tokens.line} vertical={false} />
        <XAxis
          dataKey="center"
          tick={{ ...tick, fontFamily: tokens.fontUI }}
          interval={0}
          angle={-18}
          textAnchor="end"
          height={52}
          tickLine={false}
          axisLine={{ stroke: tokens.lineStrong }}
        />
        <YAxis tick={tick} width={48} tickLine={false} axisLine={false} tickFormatter={fmtNumber} />
        <Tooltip
          contentStyle={{
            fontFamily: tokens.fontUI,
            fontSize: 12,
            border: `1px solid ${tokens.line}`,
            borderRadius: 4,
          }}
          formatter={(value, name) => [fmtNumber(value), name]}
        />
        <Legend wrapperStyle={{ fontSize: 11.5, fontFamily: tokens.fontUI }} iconSize={9} />
        {STATUS_SERIES.map((s) => (
          <Bar key={s.key} dataKey={s.key} stackId="hs" fill={s.color} name={s.key} barSize={28} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
